module.exports = __webpack_public_path__ + "img/hotel-do-chiado.78cb7c9a.jpg";